import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const CustomerAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.customerAccess
        ? setValues((j) => ({
            ...j,
            customer: {
              create: true,
              edit: true,
              delete: true,
              receivePayment: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            customer: {
              create: false,
              edit: false,
              delete: false,
              receivePayment: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.customerAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      customer: { ...j.customer, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.customerAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.customer?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.customer?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.customer?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Receive Payment"
          checked={values.customer?.receivePayment || false}
          name={"receivePayment"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default CustomerAccess;
